module.exports = __webpack_public_path__ + "static/scale-model-of-honeycutt-park-in-fayetteville-north-carolina-a9fffabcc36ac99d85afa5e3dfcbaf22.png";